import { render, staticRenderFns } from "./payment-card-property.vue?vue&type=template&id=35295650&scoped=true&"
import script from "./payment-card-property.vue?vue&type=script&lang=js&"
export * from "./payment-card-property.vue?vue&type=script&lang=js&"
import style0 from "./payment-card-property.vue?vue&type=style&index=0&id=35295650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35295650",
  null
  
)

export default component.exports